import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get_sample_types } from '../../../../redux/po_backlog/backlog.selector';
import OpenPODataGrid from './OpenPODataGrid';
import { Box, Tab, Tabs } from '@mui/material';
import OptimusTabPanel from '../../../../common/components/TabUI/TabPanel';
import { mixpanelTrackTabs } from '../../../../mixPanelFunctions/mixPanelFunctions';

const AllPos = ({ hidden_fields = [] }) => {
  const sample_types = useSelector(get_sample_types);
  // console.log((sample_types));
  const [poTabValue, setPoTabValue] = useState(0);

  const handlePoTabChange = (event, newValue) => {
    setPoTabValue(newValue);
  };

  useEffect(()=>{ 
   if(sample_types && sample_types?.length > 0){
    mixpanelTrackTabs(sample_types[poTabValue] === "CB" ? "In Process" : sample_types[poTabValue] === "FP" ? "FP Pack" : sample_types[poTabValue],"home page open po")
   }
  },[poTabValue])

  return (
    <div>
      <Box className="flex justify-between items-baseline">
        <Tabs
          className='flex-1'
          sx={{
            borderBottom: '1px solid #e8e8e8',
            '& .MuiTabs-indicator': {
              backgroundColor: '#084298',
              display: "flex",
              justifyContent: "center"
            },
            '& .MuiTabs-indicatorSpan': {
              maxWidth: 40,
              width: '100%',
              // backgroundColor: '#635ee7',
            },
          }}
          value={poTabValue}
          onChange={handlePoTabChange}
          variant="scrollable"
          scrollButtons={false}
          aria-label="scrollable prevent tabs"
        >
          {
            sample_types && sample_types?.map((sample_type, idx) => <Tab disableRipple label={sample_type === "CB" ? "In Process" : sample_type === "FP" ? "FP Pack" : sample_type} key={`Open Po-${sample_type}-${idx}`} />)
          }
        </Tabs>
        {/* <Box>
              <Button onClick={() => {
                generateExcel(poTabValue);
              }}>Download Excel</Button>
            </Box> */}
      </Box>
      {
        sample_types && sample_types?.length > 0 && sample_types?.map((sample_type, idx) =>
          <OptimusTabPanel value={poTabValue} index={idx} key={`open-po-table-${idx}`}>
            <Box sx={{ bgcolor: "white" }}>
              {/* OPEN PO Table */}
              <Box className="col-span-3">
                {
                  <OpenPODataGrid category={sample_type} hidden_fields={hidden_fields} />
                }
              </Box>
            </Box>
          </OptimusTabPanel>
        )
      }
    </div>
  );
};

export default AllPos;